/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: CrudIntegration
 * Reason: Full view for LogicFlow OBC — provides navigation items for designer, tests, executions, and messages tabs.
 */
import {Component, OnInit} from '@angular/core';
import {LgLogicFlowObjectBaseComponent} from "../lg-logic-flow-object-base.component";

@Component({
    selector: 'mvs-lg-logic-flow-object-component-full',
    templateUrl: 'lg-logic-flow-object-full.component.html',
    styleUrls: ['lg-logic-flow-object-full.component.scss'],
    standalone: false
})
export class LgLogicFlowObjectFullComponent extends LgLogicFlowObjectBaseComponent implements OnInit {

    /**
     * load and initialize sidebar navigations
     */
    loadSideBarMenuItems() {
        this.navigationItems = [
            {
                label: 'designer',
                action: 'designer',
                tooltip: 'Flow-Designer',
                icon: 'fa-regular fa-bezier-curve',
                toggleable: false,
                default: true
            },
            {
                label: 'tests',
                action: 'tests',
                tooltip: 'Testfälle',
                icon: 'fa-regular fa-flask-vial',
                toggleable: false,
            },
            {
                label: 'executions',
                action: 'executions',
                tooltip: 'Ausführungen',
                icon: 'fa-regular fa-play',
                toggleable: false,
            },
            {
                label: 'messages',
                action: 'messages',
                tooltip: 'Nachrichten',
                icon: 'fa-regular fa-message-lines',
                toggleable: false,
            },
        ];

        this.activeNavigationItem = this.navigationItems[0];
        this.handleNavigationItemsChange();
    }
}
